<template>
  <BaseFetchData :action="fetchData">
    <!-- props
      fetchData, status.loading, status.resolved, status.rejected, rejectReason
    -->
    <template #default="fetchDataProps">
      <div v-if="fetchDataProps.status.resolved" class="flex-1 flex flex-col">
        <div class="flex-none">
          <ul class="text-sm py-3 sm:py-4 space-y-3 sm:space-y-4 antialiased">
            <li class="px-4 sm:px-6">
              <span class="text-gray-600">From:</span> <span>{{ fromAddress }}</span>
            </li>
            <li class="px-4 sm:px-6">
              <span class="text-gray-600">To:</span> <span>{{ toAddress }}</span>
            </li>
            <li class="px-4 sm:px-6">
              <span class="text-gray-600">Subject:</span> <span>{{ subject }}</span>
            </li>
          </ul>
        </div>
        <div class="flex-1 border-t">
          <iframe
            src="about:blank"
            :srcdoc="emailMessage.email_message_preview.html"
            class="w-full h-full"
          />
        </div>
        <div class="flex-none p-4 sm:p-6 border-t">
          <div class="flex justify-end gap-4">
            <BaseButton primary outline @click="$emit('edit')"> Back </BaseButton>
            <BaseButton type="button" success @click="$emit('send')"> Send </BaseButton>
          </div>
        </div>
      </div>
    </template>
  </BaseFetchData>
</template>

<script>
import { contactDraftEmailMessagesClient } from '@/api/clients';

export default {
  props: {
    contactId: {
      type: String,
      required: true,
    },
    emailMessageId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      emailMessage: null,
    };
  },
  computed: {
    fromAddress() {
      return this.emailMessage?.third_party_service?.config?.from_email || 'N/A';
    },
    toAddress() {
      return this.emailMessage?.to_address || 'N/A';
    },
    subject() {
      return this.emailMessage?.subject || 'N/A';
    },
  },
  methods: {
    async fetchData() {
      try {
        const response = await contactDraftEmailMessagesClient.read(
          this.contactId,
          this.emailMessageId
        );

        this.emailMessage = response.data;

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
